export const ApproveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
            <path
                fill="#6E99F4"
                d="M11.022.32c-5.9 0-10.7 4.802-10.7 10.702s4.8 10.7 10.7 10.7c5.9 0 10.701-4.8 10.701-10.7 0-5.9-4.8-10.701-10.7-10.701zm5.322 8.417l-6.16 5.842a.934.934 0 01-.608.232.787.787 0 01-.607-.26l-3.24-3.326a.839.839 0 01.03-1.215.839.839 0 011.214.029l2.632 2.718 5.553-5.263c.347-.318.896-.318 1.214.029.319.318.319.867-.028 1.214z"
            ></path>
        </svg>
    );
};
